import { useCallback } from 'react'
import { FieldValues, Path, UseFormReturn } from 'react-hook-form'

export function useFormNav<T extends FieldValues>(
  form: UseFormReturn<T>,
  ordered: ReadonlyArray<Path<T>>,
) {
  const registerNav = useCallback(
    (name: Path<T>) => {
      const i = ordered.indexOf(name)
      const isLast = i === ordered.length - 1
      const next = ordered[i + 1]

      const handleSubmitEditing = () => {
        if (next) {
          form.setFocus(next)
        }
      }

      return {
        returnKeyType: isLast ? 'done' : 'next',
        blurOnSubmit: isLast || !next,
        onSubmitEditing: handleSubmitEditing,
      } as const
    },
    [ordered, form],
  )

  return { registerNav }
}
